// Sección técnica privada del cobro Point (nunca muestra token ni credenciales)
export const PointTech = ({ tech }) => (
  <details className="w-full text-left mt-2 border border-white/10 bg-black/30" data-testid="point-tech">
    <summary className="cursor-pointer px-3 py-2 text-[10px] uppercase tracking-wider font-bold text-white/40 select-none">Detalle técnico</summary>
    <div className="px-3 py-2 space-y-1 font-mono text-[11px] text-white/60">
      <div>endpoint: <span className="text-white/80">{tech.endpoint || "—"}</span></div>
      <div>http_status: <span className="text-white/80">{tech.http_status ?? "—"}</span></div>
      <div>order.id: <span className="text-white/80">{tech.order_id || "—"}</span></div>
      <div>order.status: <span className="text-white/80">{tech.order_status || "—"}</span></div>
      <div>status_detail: <span className="text-white/80">{tech.status_detail || "—"}</span></div>
      <div>terminal_id: <span className="text-white/80">{tech.terminal_id || "—"}</span></div>
      <div>date_created: <span className="text-white/80">{tech.date_created || "—"}</span></div>
    </div>
  </details>
);

export default PointTech;
